<template>
  <div>
    <el-form :disabled="allcomponentsDisabledfun(element,'table')" ref="tableForm" label-position="right" inline-message class="demo-table-expand circles" :model="childrensInfo">
      <!-- 子表按钮解析 -->
      <div style="position: absolute; top:5px; right:45px;">
        <template v-if="!element.options.complexoptions && isCanEditDetailInfo">
          <template v-for="(val,idx) in element.buttonlists">
            <!-- 正常按钮 -->
            <el-button :disabled="allcomponentsDisabledfun(val,'button')" v-if="val.options.event != 'importData' && val.options.event != 'customimportData'" :key="idx" :type="val.options.type" size="mini" :plain="val.options.isPlain" :circle="val.options.isCircle" :loading="val.options.isLoading" @click="btnClick(val)">
              <i class="mr5" :class="val.options.icon"></i>
              <font>{{val.options.text}}</font>
            </el-button>
            <!-- 主表id存在的导入按钮 -->
            <template v-if="!!detailInfos.id">
              <!-- 子表导入按钮 -->
              <el-upload :disabled="allcomponentsDisabledfun(val,'button')" class="pl5" v-if="val.options.event == 'importData'" style="display: inline-block" :key="idx" ref="myupload1" action :on-change="importData" :file-list="fileListUpload" :limit="limitUpload" :auto-upload="false" :show-file-list='false'>
                <el-button :disabled="allcomponentsDisabledfun(val,'button')" @click="importDataBtn(val)" :type="val.options.type" size="mini" :plain="val.options.isPlain" :circle="val.options.isCircle" :loading="val.options.isLoading">
                  <i class="mr5" :class="val.options.icon"></i>
                  <font>{{val.options.text}}</font>
                </el-button>
              </el-upload>
              <!-- 子表自定义导入按钮 -->
              <el-upload :disabled="allcomponentsDisabledfun(val,'button')" class="pl5" v-if="val.options.event == 'customimportData'" style="display: inline-block" :key="idx" ref="myupload2" action :on-change="customimportData" :file-list="fileListUpload" :limit="limitUpload" :auto-upload="false" :show-file-list='false'>
                <el-button :disabled="allcomponentsDisabledfun(val,'button')" @click="customimportDataBtn(val)" :type="val.options.type" size="mini" :plain="val.options.isPlain" :circle="val.options.isCircle" :loading="val.options.isLoading">
                  <i class="mr5" :class="val.options.icon"></i>
                  <font>{{val.options.text}}</font>
                </el-button>
              </el-upload>
            </template>
            <!-- 主表id不存在的导入按钮 -->
            <template v-if="!detailInfos.id">
              <!-- 导入按钮 -->
              <el-button :disabled="allcomponentsDisabledfun(val,'button')" :key="idx" :type="val.options.type" size="mini" @click="noimportData" v-if="val.options.event == 'importData'" :plain="val.options.isPlain" :circle="val.options.isCircle" :loading="val.options.isLoading">
                <i :class="val.options.icon"></i>
                <font>{{val.options.text}}</font>
              </el-button>
              <!-- 自定义导入按钮 -->
              <el-button :disabled="allcomponentsDisabledfun(val,'button')" :key="idx" :type="val.options.type" size="mini" @click="nocustomimportData" v-if="val.options.event == 'customimportData'" :plain="val.options.isPlain" :circle="val.options.isCircle" :loading="val.options.isLoading">
                <i :class="val.options.icon"></i>
                <font>{{val.options.text}}</font>
              </el-button>
            </template>
          </template>
        </template>
        <el-popover class="ml5" v-model="isshowpopover" popper-class="tablecolumnscontrol-popover" placement="bottom-start" width="180" trigger="click">
          <div class="tablecolumnscontrol">
            <div class="tablecolumnscontrol-content">
              <el-row v-if="element.columns">
                <el-col v-for="(val,idx) in tableallCheckList" :key="idx" :span="24">
                  <el-switch v-model="val.isSelect" active-color="#08979c" :active-value="1" :inactive-value="0"></el-switch>{{val.name}}
                </el-col>
              </el-row>
            </div>
            <div class="tablecolumnscontrol-footer">
              <el-button size="mini" type="primary" @click="saveTableColumn">保存</el-button>
              <el-button size="mini" @click="resetTableColumn">重置</el-button>
            </div>
          </div>
          <el-button slot="reference" class="tablecolumnscontrolBtn" size="mini" icon="el-icon-s-operation"></el-button>
        </el-popover>
      </div>
      <!-- 子表高级搜索解析 -->
      <el-row :gutter="20" v-if="element.options.isSearch">
        <el-form inline-message :model="searchList" label-width="100px">
          <el-col v-for="(val,idx) in element.columns" :key="idx" :span="6">
            <el-form-item :label="val.name" v-if="val.options.isforsearch && !val.options.isvisible">
              <el-input size="mini" v-model="searchList[val.model]" v-if="val.type=='input'" @keyup.enter.native="searchBtn"></el-input>
              <!-- <el-date-picker size="mini" v-model="searchList[val.model]" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" v-if="val.type=='date'"></el-date-picker>
                            <el-date-picker v-model="searchList[val.model]" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间" v-if="val.type=='datetime'"></el-date-picker> -->
              <el-date-picker align="center" style="width:100%" v-if="val.type=='date'" v-model="searchList[val.model]" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
              <el-date-picker style="width:100%" v-if="val.type=='datetime'" v-model="searchList[val.model]" type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
              <el-select clearable style="width:100%" size="mini" v-model="searchList[val.model]" placeholder="请选择" v-if="val.type=='select' && val.options.remote == 1">
                <el-option v-for="item in val.options.selectData" :key="item.id" :value="item.code" :label="item.name">
                </el-option>
              </el-select>
              <el-select style="width:100%" clearable size="mini" v-model="searchList[val.model]" placeholder="请选择" v-if="val.type=='select' && val.options.remote == 2">
                <el-option v-for="item in val.options.selectData" :key="item.id" :value="item[val.options.remoteData.value]" :label="item[val.options.remoteData.label]">
                </el-option>
              </el-select>
              <el-date-picker size="mini" v-if="val.type == 'allDatePicker' && val.options.type == 'year'" v-model="searchList[val.model]" type="year" placeholder="选择年" style="width:100%" value-format="yyyy"></el-date-picker>
              <el-date-picker size="mini" v-if="val.type == 'allDatePicker' && val.options.type == 'month'" v-model="searchList[val.model]" type="month" placeholder="选择月" style="width:100%" value-format="yyyy-MM"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" style="line-height:40px">
            <el-button icon="icon-search" class="btn btn-blue" size="mini" type="primary" @click="searchBtn">搜索</el-button>
            <el-button icon="icon-refresh" class="btn-blue" size="mini" @click="resetBtn">重置</el-button>
          </el-col>
        </el-form>
      </el-row>
      <!-- 子表解析 -->
      <el-table v-loading="childloading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.5)" ref="childTable" :data="tableData" :row-key='getRowKeys' style="width: 100%;" stripe highlight-current-row :row-class-name='rowClassName' :cell-class-name="cellClassName" @selection-change="selectTableData" @sort-change="tableSortChange">
        <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
        <el-table-column type="index" label="序号" width="50" v-if="!element.options.isHiddenOrderNumber">
          <template slot-scope="scope">
            <span>{{(page.currentPage-1)*page.pageSize+scope.$index+1}}</span>
          </template>
        </el-table-column>
        <template v-for="item in element.columns">
          <el-table-column v-if="!item.options.isvisible && item.options.isshowntable && tablenoCheckList.indexOf(item.model) == -1" sortable="custom" :width="item.options.width == '100%' ? '' : item.options.width" :key="item.id" :label="item.name" :prop="item.model">
            <template slot-scope="props">
              <widget-form-item :element="item" :isChild='true' :isChildList='true' :currentListchildData="props.row" :childDetailJson="JSON.parse(JSON.stringify(element.detailcolumns))" :childName="element.options.uniqueIdentification" :currentChild="element" :parentRowData="parentRowData"></widget-form-item>
            </template>
          </el-table-column>
        </template>
        <el-table-column v-if="!element.options.complexoptions" label="操作" :width="element.options.operationcolumnwidth ? element.options.operationcolumnwidth : 100" align="center">
          <template slot-scope="props">
            <span class="blue mr10" style="fontSize:13px" @click="viewBtn(props.row)">详情</span>
            <span class="orangered" style="fontSize:13px" v-if="!allcomponentsDisabledfun(element,'table') && isCanEditDetailInfo" @click="del(props.$index,props.row)">删除</span>
            <span class="blue ml10" style="fontSize:13px" v-if="element.options.hierarchy > 0" @click="viewChildren(props.row)">查看子级</span>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <el-pagination background layout="prev, pager, next,sizes,total,jumper" :current-page="page.currentPages" :page-sizes="[10, 20, 30, 40, 60, 80, 100, 150, 200]" :page-size="page.pageSize" :total="page.totalCount" @size-change="sizeChange" @current-change="currentChange"></el-pagination>
    <!-- 新建/编辑弹出框 -->
    <div class="popupBox" v-if="isShowModel" ref="popupBox">
      <div class="popupBox-content" ref="popupBoxContent">
        <div class="popupBox-content-header">
          <span class="popupBox-content-header-title">{{modeltitle}}</span>
          <span class="popupBox-content-header-close"><i class="icon-close1" @click="closeModel"></i></span>
          <span class="popupBox-content-header-close"><i :class="{'icon-restore': ischangeView , 'icon-maximization' : !ischangeView}" @click="changeView"></i></span>
        </div>
        <div class="popupBox-content-body" v-loading="modelloading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.5)">
          <el-form :disabled="allcomponentsDisabledfun(element,'table')" ref="childForm" :model="currentAppChildRowData" :size="jsonData.config.size" :label-position="jsonData.config.labelPosition" :label-width="jsonData.config.labelWidth + 'px'">
            <childrecursiveComponent :jsonData="element.detailcolumns" :childDetailJson="JSON.parse(JSON.stringify(element.detailcolumns))" :childData="{}" :childName="element.options.uniqueIdentification" :currentChild="element" :parentRowData="parentRowData"></childrecursiveComponent>
          </el-form>
        </div>
        <div class="popupBox-content-footer" v-if="!element.options.complexoptions && !allcomponentsDisabledfun(element,'table')">
          <el-button v-if="modeltitle == '查看' && !allcomponentsDisabledfun(element,'table') && isCanEditDetailInfo" type="primary" size="mini" @click="editBtn"><i class="icon-save mr5"></i>
            <font>编辑</font>
          </el-button>
          <el-button v-if="!isEditData" type="primary" size="mini" @click="saveBtn"><i class="icon-save mr5"></i>
            <font>保存</font>
          </el-button>
          <el-button v-if="!isEditData" class="closeBtn" size="mini" @click="closeModel"><i class="icon-close2 mr5"></i>
            <font>取消</font>
          </el-button>
        </div>
      </div>
    </div>
    <batch-components ref="batchComponents" :element="batchchooseParam" @updateBatch='updateBatch'></batch-components>
    <!-- 客户化组件 -->
    <customizationComponents ref="customizationComponents"></customizationComponents>
  </div>
</template>

<script>

import { Loading } from 'element-ui'
import childrecursiveComponent from "./childrecursiveComponent"
import widgetFormItem from "./widgetFormItem.vue"
import batchComponents from "./batchComponents"
import customizationComponents from "@/page/zhonglv/zhonglv.vue"  //客户化处理组件
export default {
  name: "childTable",
  props: ["element"],
  components: { childrecursiveComponent, widgetFormItem, batchComponents, customizationComponents },
  data() {
    return {
      basic_url: Config.dev_url,//请求地址
      fileListUpload: [],
      limitUpload: 1, //限制上传文件个数
      customimportDataBtnItem: {}, //自定义导入按钮当前信息
      importDataBtnItem: {}, //导入按钮当前信息
      parentRowData: {},//父级数据
      frontid: 0,  //表格唯一标识
      page: {     //分页
        currentPage: 1,
        pageSize: 10,
        totalCount: 0
      },
      isshowpopover: false,   //是否显示表格控制列
      tableallCheckList: [],  //表格控制列所有信息
      tablenoCheckList: [],   //表格控制列未选择信息
      searchList: {},  //高级搜索条件
      drawer: false,   //高级搜索抽屉
      childSelectData: [], //子表选中的数据
      isShowModel: false,
      modeltitle: "新建",
      modelloading: false,
      childloading: false,
      isEditData: false,
      ischangeView: false,
      //子表多选按钮
      batchchooseParam: {  //初始值
        options: {
          remoteData: {}
        }
      },
      usefalsepageChildData: []
    }
  },
  computed: {
    isUsefalsepage() {
      return this.$store.state.isUsefalsepage
    },
    //表格model值
    tableData: {
      get: function () {
        return (this.element.options.disabled ? this.childrensInfo[this.element.options.uniqueIdentification + 'Readonly'] : (this.element.options.isadoptUrlGetData ? this.childrensInfo[this.element.options.uniqueIdentification + 'Readonly'] : (this.isUsefalsepage ? this.childrensInfo[this.element.options.uniqueIdentification + "Usefalsepage"] : this.childrensInfo[this.element.options.uniqueIdentification])))
      },
      set: function () {

      },
    },
    //主表信息
    detailInfos() {
      return this.$store.state.detailInfo
    },
    //当前登录人信息
    currentuser() {
      return this.$store.state.currentuser
    },
    //子表信息
    childrensInfo() {
      return this.$store.state.childrensInfo
    },
    //是否请求子表数据
    isrequestChildTableData() {
      return this.$store.state.isrequestChildTableData
    },
    //是否可编辑主表信息
    isCanEditDetailInfo() {
      return this.$store.state.isCanEditDetailInfo
    },
    //当前子表某一条数据信息
    currentAppChildRowData() {
      return this.$store.state.currentAppChildRowData
    },
    //当前应用的json信息
    jsonData() {
      return this.$store.state.jsonData
    },
    //当前应用的所有子表json信息
    childTableJson() {
      return this.$store.state.childTableJson
    },
    istouchvalidateChild() {
      return this.$store.state.istouchvalidateChild
    },
    validateChildFormResult() {
      return this.$store.state.validateChildFormResult
    },
  },
  watch: {
    //监听主表选中状态操作完之后初始化
    isrequestChildTableData(val) {
      if (val) {
        if (!!this.detailInfos.id) {
          this.getData()
          //判断当前子表是否存在自增字段
          if (!!this.element.options.autoAddFiled) {
            this.getMaxNum()
          }
        } else {
          this.initData()
        }
      }
    },
    isUsefalsepage(val) {
      if (val) {
        var childData = this.childrensInfo[this.element.options.uniqueIdentification]
        this.page.totalCount = childData.length
        this.usefalsepageChildData = []
        for (var i = 0; i < childData.length; i += 10) {
          this.usefalsepageChildData.push(childData.slice(i, Math.min(i + 10, childData.length)))
        }
        this.childrensInfo[this.tableData] = this.usefalsepageChildData[0]
      }
    },
  },
  methods: {
    //多选按钮
    batchChoose(val) {
      var obj = {};
      var newArr = this.recursionJson(this.element.detailcolumns, [])
      newArr.forEach((newArrItem) => {
        if (newArrItem.options.hasOwnProperty('defaultValue')) {
          var defaultValuefield = newArrItem.options.defaultValue
          if (!!defaultValuefield) {
            if (isNaN(defaultValuefield)) {
              if (defaultValuefield.indexOf('currentuser:') !== -1) {
                if (defaultValuefield.indexOf('createtime') !== -1) {
                  obj[newArrItem.model] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
                } else {
                  obj[newArrItem.model] = this.currentuser[defaultValuefield.substr(defaultValuefield.indexOf('currentuser:') + 12, defaultValuefield.length)]
                }
              } else if (defaultValuefield.indexOf('m:') !== -1) {
                obj[newArrItem.model] = this.detailInfos[defaultValuefield.substr(defaultValuefield.indexOf('m:') + 2, defaultValuefield.length)]
              } else {
                obj[newArrItem.model] = defaultValuefield
              }
            } else {
              obj[newArrItem.model] = defaultValuefield
            }
          } else {
            obj[newArrItem.model] = ''
          }
        } else {
          obj[newArrItem.model] = ''
        }
      })
      if (this.childrensInfo[this.element.options.uniqueIdentification] == undefined) {
        this.childrensInfo[this.element.options.uniqueIdentification] = []
      }
      this.batchchooseParam = val;
      this.$refs.batchComponents.view(val, this.childrensInfo[this.element.options.uniqueIdentification], obj)
    },
    updateBatch(data) {
      for (var m = 0; m < data.length; m++) {
        data[m].frontid = this.frontid++;
        this.childrensInfo[this.element.options.uniqueIdentification].push(data[m])
      }
      this.$store.commit('setDataChangeStatus', 1)
    },
    //表单验证
    validateForm() {
      var validateFlag = true
      this.$refs.tableForm.validate((valid) => {
        if (valid) {
          validateFlag = true;
        } else {
          validateFlag = false;
        }
      })
      var obj = {
        childidentification: this.element.options.uniqueIdentification,
        validateFlag: validateFlag
      }
      var validateChildResult = this.validateChildFormResult.some((val) => {
        return val.childidentification == obj.childidentification
      })
      if (validateChildResult) {
        for (var i = 0; i < this.validateChildFormResult.length; i++) {
          if (this.validateChildFormResult[i].childidentification == obj.childidentification) {
            this.validateChildFormResult[i].validateFlag = obj.validateFlag
          }
        }
      } else {
        this.validateChildFormResult.push(obj)
      }
    },
    changeView() {
      this.ischangeView = !this.ischangeView
      this.$nextTick(() => {
        if (this.ischangeView) {
          this.$refs.popupBox.style.padding = 0
          this.$refs.popupBoxContent.style.width = "100%"
          this.$refs.popupBoxContent.style.height = "100%"
        } else {
          this.$refs.popupBox.style.padding = "40px 0px"
          this.$refs.popupBoxContent.style.width = "900px"
          this.$refs.popupBoxContent.style.height = "unset"
        }
        this.$refs.popupBox.style.transition = "all 0.3s ease-in 0s"
        this.$refs.popupBoxContent.style.transition = "all 0.3s ease-in 0s"
      })
    },
    //保存按钮
    saveBtn() {
      console.log(this.jsonData)
      this.$refs.childForm.validate((valid) => {
        if (valid) {
          console.log(this.currentAppChildRowData)
          var data = this.currentAppChildRowData
          //判断当前保存的得子表是否为多级子表，并推入正确的关联关系
          var relationData = this.element.options.hierarchy > 1 ? this.parentRowData : this.detailInfos
          if (!data.id) {  //代表子表新建时，往当前数据放入关联关系
            if (this.element.options.relationOptions.length !== 0) {
              for (var i = 0; i < this.element.options.relationOptions.length; i++) {
                if (this.element.options.relationOptions[i].relationChildfield.indexOf(":") == -1) { //固定值
                  data[this.element.options.relationOptions[i].relationParentfield] = this.element.options.relationOptions[i].relationChildfield
                } else {
                  data[this.element.options.relationOptions[i].relationParentfield] = relationData[this.element
                    .options.relationOptions[i].relationChildfield.substring(1, this.element.options.relationOptions[i].relationChildfield
                      .length)]
                }
              }
            }
          }
          for (let key in data) {
            if (key.indexOf('CheckboxModel') != -1) {
              data[key.substr(0, key.indexOf('CheckboxModel'))] = data[key].join(',')
            } else if (key.indexOf('SelectBox') != -1) {
              data[key.substr(0, key.indexOf('SelectBox'))] = data[key].join(',')
            } else {
              data[key] = data[key]
            }
          }
          var url = Config.dev_url + "/api-apps/app/" + this.$route.params.app + '/saveOrUpdateChild?child=' + this.element.options.tablename
          console.log(data, "子表保存的数据")
          this.modelloading = true
          this.$axios.post(url, data).then((res) => {
            this.modelloading = false
            this.isShowModel = false
            if (res.data.code == 0) {
              this.$message.success("保存成功")
              this.$store.commit("setcurrentAppChildRowData", res.data.data)
              this.$store.commit('setisrequestChildenclosureForDetail', true)
              this.getData()
            } else {
              this.$message.warning(res.data.msg)
            }
          }).catch((err) => {
          });
        }
      })
    },
    //关闭编辑弹框
    closeModel() {
      this.isShowModel = false
      this.ischangeView = false;
      this.getData()
    },
    //表格某一行点击
    viewChildren(row) {
      console.log(row, this.childTableJson)
      this.childTableJson.forEach((childJsonItem) => {
        if (this.element.options.uniqueIdentification == childJsonItem.options.parentUniqueIdentification) {
          this.$emit('childRowClick', childJsonItem, row, this.element)
        }
      })
    },
    //多级子表控制是否可编辑
    updateOperation(val) {
      if (!this.element.options.disabled) {
        this.element.options.hierarchydisabled = val
      }
    },
    //获取子表数据
    getData(str, row, defaultData) {
      if (!!this.detailInfos.id) {
        this.parentRowData = row
        if (!str) {
          this.page.currentPage = 1;
          this.page.pageSize = 10;
          this.page.totalCount = 0;
        }
        var data = {
          page: this.page.currentPage,
          limit: this.page.pageSize,
        }
        if (str == '排序') {
          for (let key in this.searchList) {
            data[key] = this.searchList[key]
          }
        }
        //处理复合关系
        var complexoptions = this.element.options.complexoptions
        if (!!complexoptions) {
          let num = 0;
          for (var j = 0; j < complexoptions.length; j++) {
            if (complexoptions[j] == ":") {
              num++
            }
          }
          if (num > 0) {
            for (var i = 0; i < num; i++) {
              for (let key in this.detailInfos) {
                var code = ':' + key
                if (Object.prototype.toString.call(this.detailInfos[key]) == "[object String]") {
                  complexoptions = complexoptions.replace(code, "'" + this.detailInfos[key] + "'")
                } else {
                  complexoptions = complexoptions.replace(code, this.detailInfos[key])
                }
              }
            }
            data.where_condition = complexoptions
          }
        }
        //通过接口获取数据
        if (this.element.options.isadoptUrlGetData) {
          if (!!this.element.options.adoptUrlGetDataUrl) {
            this.element.options.adoptUrlGetDataOptions.forEach((adoptItem) => {
              if (adoptItem.value.indexOf("m:") !== -1) {
                data[adoptItem.key] = this.detailInfos[adoptItem.value.substring(2, adoptItem.value.length)]
              } else {
                data[adoptItem.key] = adoptItem.value
              }
            })
            if (this.element.options.adoptUrlGetDataMethod == 'get') {
              if (JSON.stringify(data) == "{}") {
                var adopturl = Config.dev_url + this.element.options.adoptUrlGetDataUrl
              } else {
                var adoptstr = ''
                for (let key in data) {
                  adoptstr += key + '=' + data[key] + '&'
                }
                var adoptparams = adoptstr.substring(0, adoptstr.length - 1)
                var adopturl = Config.dev_url + this.element.options.adoptUrlGetDataUrl + '?' + adoptparams
                this.childloading = true
                this.$axios.get(adopturl, data).then((res) => {
                  this.childloading = false
                  for (var i = 0; i < res.data.data.length; i++) {
                    res.data.data[i].frontid = this.frontid++;
                  }
                  this.$set(this.childrensInfo, this.element.options.uniqueIdentification + 'Readonly', res.data.data)
                  this.$nextTick(() => {
                    this.$store.commit('setisrequestChildTableData', false)
                    this.$store.commit("setisUsefalsepage", false)
                  })
                }).catch((err) => {
                });
              }
            } else {
              var adopturl = Config.dev_url + this.element.options.adoptUrlGetDataUrl
              this.childloading = true
              this.$axios.post(adopturl, data).then((res) => {
                this.childloading = false
                for (var i = 0; i < res.data.data.length; i++) {
                  res.data.data[i].frontid = this.frontid++;
                }
                this.$set(this.childrensInfo, this.element.options.uniqueIdentification + 'Readonly', res.data.data)
                this.$nextTick(() => {
                  this.$store.commit('setisrequestChildTableData', false)
                  this.$store.commit("setisUsefalsepage", false)
                })
              }).catch((err) => {
              });
            }
          }
        } else {
          if (!!this.element.options.tablename) {
            var url = Config.dev_url + '/api-apps/app/' + this.$route.params.app + '/object?object=' + this.element.options.tablename
            if (!!this.element.options.uniqueIdentification && !!this.element.options.parentUniqueIdentification && this.element.options.hierarchy > 1) {  //多级子表
              console.log("多级子表")
              if (!!this.element.options.relationOptions && !!row && JSON.stringify(row) !== "{}") {
                this.element.options.relationOptions.forEach((relItem) => {
                  if (relItem.relationChildfield.indexOf(":") == -1) {  //固定值
                    data[relItem.relationParentfield + '_wheres'] = relItem.relationChildfield
                  } else {  //从父表中取值
                    data[relItem.relationParentfield + '_wheres'] = row[relItem.relationChildfield.substring(1, relItem.relationChildfield.length)]
                  }
                })
              } else {
                this.initData()
                return
              }
            } else {  //一级子表
              if (!!this.element.options.relationOptions) {
                this.element.options.relationOptions.forEach((relItem) => {
                  if (relItem.relationChildfield.indexOf(":") == -1) {  //固定值
                    data[relItem.relationParentfield + '_wheres'] = relItem.relationChildfield
                  } else {  //从父表中取值
                    data[relItem.relationParentfield + '_wheres'] = this.detailInfos[relItem.relationChildfield.substring(1, relItem.relationChildfield.length)]
                  }
                })
              }
            }
            this.childloading = true
            this.$axios.post(url, data).then((res) => {
              this.childloading = false
              if (res.status == 200) {
                for (var i = 0; i < res.data.data.length; i++) {
                  res.data.data[i].frontid = this.frontid++;
                }
                if (!!this.$refs.childTable) {
                  this.$refs.childTable.clearSelection()
                }
                this.page.totalCount = res.data.count
                if (!this.element.options.disabled) {
                  this.$set(this.childrensInfo, this.element.options.uniqueIdentification, res.data.data)
                } else {
                  this.$set(this.childrensInfo, this.element.options.uniqueIdentification + 'Readonly', res.data.data)
                }
                //  处理多级子表数据组合
                if (this.element.options.hierarchy > 1 && !!this.element.options.parentUniqueIdentification && !!this.childrensInfo[this.element.options.parentUniqueIdentification] && !!row && !this.element.options.disabled) {
                  this.childrensInfo[this.element.options.parentUniqueIdentification].forEach((parentDataItem) => {
                    if ((parentDataItem.id || parentDataItem.ID) == (row.id || ID)) {
                      parentDataItem[this.element.options.uniqueIdentification] = res.data.data
                    } else {
                      parentDataItem[this.element.options.uniqueIdentification] = []
                    }
                  })
                }
                //数据更改记录变化得数据  分页切换时对比赋值
                var currentChildChangeData = this.childrensInfo[this.element.options.uniqueIdentification + 'ChangeData']
                var currentChildData = this.childrensInfo[this.element.options.uniqueIdentification]
                if (!!currentChildChangeData) {
                  currentChildChangeData.forEach((item) => {
                    for (var i = 0; i < currentChildData.length; i++) {
                      if (item.id == currentChildData[i].id) {
                        currentChildData[i] = item
                      }
                    }
                  })
                }
                this.$nextTick(() => {
                  this.$store.commit('setisrequestChildTableData', false)
                  this.$store.commit("setisUsefalsepage", false)
                })
              } else {
                this.$message.warning(res.statusText)
              }
            }).catch((err) => {
            });
          }
        }
      } else {
        this.initData()
      }
    },
    //初始化表格
    initData() {
      if (this.element.options.hierarchy > 1) {
        this.element.options.hierarchydisabled = true
      }
      if (!this.tableData || this.tableData.length == 0) {
        if (this.element.options.disabled || this.element.options.isadoptUrlGetData) {
          this.$set(this.childrensInfo, this.element.options.uniqueIdentification + 'Readonly', [])
        } else if (this.isUsefalsepage) {
          this.$set(this.childrensInfo, this.element.options.uniqueIdentification + 'Usefalsepage', [])
        } else {
          this.$set(this.childrensInfo, this.element.options.uniqueIdentification, [])
        }
      }
      this.$nextTick(() => {
        this.$store.commit('setisrequestChildTableData', false)
        this.$store.commit("setisUsefalsepage", false)
      })
    },
    closeSearchTagBtn(val) {
      this.searchList[val.model] = ""
      this.getData('排序', this.parentRowData)
    },
    //搜索按钮
    searchBtn() {
      this.page.currentPage = 1
      this.element.columns.forEach((item) => {
        if (item.options.isforsearch) {
          if (item.type == "date" || item.type == "datetime") {
            if (!!this.searchList[item.model]) {
              console.log(item, this.searchList[item.model])
              this.searchList[item.model + "_where_date_from"] = this.searchList[item.model][0]
              this.searchList[item.model + "_where_date_to"] = this.searchList[item.model][1]
            } else {
              delete this.searchList[item.model + "_where_date_from"]
              delete this.searchList[item.model + "_where_date_to"]
            }
            delete this.searchList[item.model]
          }
        }
      })
      this.getData('排序', this.parentRowData)
      this.drawer = false
    },
    //重置按钮
    resetBtn() {
      this.element.columns.forEach((item) => {
        if (item.options.isforsearch && !!this.searchList[item.model]) {
          delete this.searchList[item.model]
        }
      })
      this.getData('', this.parentRowData)
      this.drawer = false
    },
    // 递归json获取基础组件信息
    recursionJson(json, arr) {
      json.forEach((item) => {
        if (item.type == 'grid') {
          item.columns.forEach((columnsItem) => {
            this.recursionJson(columnsItem.list, arr)
          })
        } else {
          arr.push(item)
        }
      })
      return arr
    },
    //编辑按钮
    editBtn() {
      this.isEditData = false
      this.modeltitle = "编辑"
      this.$store.commit('setisCanEditChildInfo', true)
    },
    initViewData(data) {
      var newArr = this.recursionJson(this.element.detailcolumns, [])
      newArr.forEach((newArrItem) => {
        if (newArrItem.type == 'checkbox') {
          this.$set(data, newArrItem.model + 'CheckboxModel', data[newArrItem.model].split(","))
        } else if (newArrItem.type == 'select' && newArrItem.options.multiple) {
          this.$set(data, newArrItem.model + 'SelectBox', data[newArrItem.model].split(","))
        } else {
           if(data[newArrItem.model] == undefined || data[newArrItem.model] == null){
              this.$set(data , newArrItem.model , "")
           }else{
              data[newArrItem.model] = data[newArrItem.model]
           }  
        }
      })
    },
    //查看按钮
    viewBtn(data) {
      this.initViewData(data)
      var frameindex = Number(localStorage.getItem("iframeindex"));
      parent.putChildShareValue(frameindex, data);
      this.$store.commit("setcurrentAppChildRowData", data)
      this.$store.commit('setisCanEditChildInfo', true)
      this.isShowModel = true
      this.isEditData = false
      this.modeltitle = "详情"
      this.$nextTick(() => {
        this.$store.commit('setisrequestChildenclosureForDetail', true)
      })
    },
    //新建行
    addLine() {
      if (!this.detailInfos.id) {
        this.$message.warning("请先保存当前数据之后再进行新建")
        return
      }
      this.isShowModel = true
      this.isEditData = false
      this.$store.commit('setisCanEditChildInfo', true)
      var obj = {};
      var newArr = this.recursionJson(this.element.detailcolumns, [])
      newArr.forEach((newArrItem) => {
        //默认值解析
        if (newArrItem.type == 'switch') {
          obj[newArrItem.model] = '0'
        } else if (newArrItem.type == 'checkbox') {
          obj[newArrItem.model + 'CheckboxModel'] = []
        } else if (newArrItem.type == 'select' && newArrItem.options.multiple) {
          obj[newArrItem.model + 'SelectBox'] = []
        } else if (newArrItem.options.hasOwnProperty('defaultValue')) {
          var defaultValuefield = newArrItem.options.defaultValue
          if (!!defaultValuefield) {
            if (isNaN(defaultValuefield)) {
              if (defaultValuefield.indexOf('currentuser:') !== -1) {
                if (defaultValuefield.indexOf('createtime') !== -1) {
                  obj[newArrItem.model] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
                } else {
                  obj[newArrItem.model] = this.currentuser[defaultValuefield.substr(defaultValuefield.indexOf('currentuser:') + 12, defaultValuefield.length)]
                }
              } else if (defaultValuefield.indexOf('m:') !== -1) {
                obj[newArrItem.model] = this.detailInfos[defaultValuefield.substr(defaultValuefield.indexOf('m:') + 2, defaultValuefield.length)]
              } else {
                obj[newArrItem.model] = defaultValuefield
              }
            } else {
              obj[newArrItem.model] = defaultValuefield
            }
          } else {
            obj[newArrItem.model] = ''
          }
        } else {
          obj[newArrItem.model] = ''
        }
      })
      //字段自增功能解析
      if (!!this.element.options.autoAddFiled) {
        if (!!this.element.options.autoAddStep) {
          var step = this.element.options.autoAddStep
        } else {
          var step = 1
        }
        obj[this.element.options.autoAddFiled] = Number((++this.maxNum) * step)
      }
      if (this.childrensInfo[this.element.options.uniqueIdentification] == undefined) {
        this.childrensInfo[this.element.options.uniqueIdentification] = []
      }
      var addurl = Config.dev_url + '/api-apps/app/' + this.$route.params.app + '/addDefault?object=' + this.element.options.tablename
      this.$axios.get(addurl).then((res) => {
        console.log(res, "新建默认值")
        if (res.data.code == 0) {
          var addDefaultData = res.data.data
          for (let key in addDefaultData) {
            obj[key] = addDefaultData[key]
          }
        }
        this.expands = [];
        obj.frontid = this.frontid++;
        this.expands.push(obj.frontid);
      }).catch((error) => {
        this.page.totalCount++
        this.expands = [];
        obj.frontid = this.frontid++;
        this.expands.push(obj.frontid);
      })
      this.$store.commit("setcurrentAppChildRowData", obj)
      console.log(obj, "新建默认值")
      if (!!this.element.options.hierarchy > 0) {  //证明是多级子表
        this.$emit('addLineBtn', this.element)
      }
    },
    //删除按钮
    del(index, row) {
      this.$confirm("确定删除选中数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(({ value }) => {
        if (!!row.id) {
          var url = Config.dev_url + '/api-apps/app/' + this.$route.params.app + '/' + this.element.options.tablename + '/' + row.id
          this.$axios.delete(url).then((res) => {
            if (res.data.code == 0) {
              this.getData()
              this.$message({
                message: "删除成功",
                type: "success"
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "warning"
              });
            }
          }).catch((err) => {
          });
        } else {
          this.childrensInfo[this.element.options.uniqueIdentification].splice(index, 1)
          this.page.totalCount--
          if (row[this.element.options.autoAddFiled] == this.maxNum) {
            --this.maxNum
          }
        }
      })
    },
    //批量删除
    batchDelBtn() {
      if (this.childSelectData.length == 0) {
        this.$message.warning("请先选择数据再进行操作");
        return;
      } else {
        var ids = [];
        for (var i = 0; i < this.childSelectData.length; i++) {
          if (!!this.childSelectData[i].id) {
            ids.push(this.childSelectData[i].id)
          }
        }
        var url = Config.dev_url + "/api-apps/app/" + this.$route.params.app + '/deletesByTable?table=' + this.element.options.tablename + '&ids=' + ids.join(',');
        this.$confirm("确定删除选中数据吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消"
        }).then(({ value }) => {
          this.$axios.delete(url).then(res => {
            if (res.data.code == 0) {
              this.$message.success("删除成功");
              this.getData()
              this.$refs.childTable.clearSelection()
            } else {
              this.$message.warning(res.data.msg);
            }
          }).catch((err) => {
          });
        });
      }
    },
    //选中表格某条数据时触发
    selectTableData(val) {
      this.childSelectData = val
    },
    //表格排序该表
    tableSortChange(column) {
      var searchObj = this.searchList;
      var str = column.prop;
      for (var key in searchObj) {
        if (key.indexOf("_orders") != -1) {
          delete searchObj[key];
        }
      }
      //兼容列表显示Desc的字段排序
      if (str.indexOf("Desc") != -1) {
        str = str.substr(0, str.length - 4);
      }
      if (column.order === "descending") {
        this.searchList[str + "_orders"] = "desc";
      } else {
        this.searchList[str + "_orders"] = "asc";
      }
      this.getData('排序', this.parentRowData)
    },
    //表格行样式
    rowClassName({ row, rowIndex, }) {
      if (!!this.element.options.controlRowColorTernaryexpression) {
        var controlRowColorTernaryexpressionArr = this.element.options.controlRowColorTernaryexpression
        for (var i = 0; i < controlRowColorTernaryexpressionArr.length; i++) {
          if (eval(controlRowColorTernaryexpressionArr[i].key)) {
            return controlRowColorTernaryexpressionArr[i].value
          }
        }
      } else {
        return ''
      }
    },
    //表格列样式
    cellClassName({ row, column, rowIndex, columnIndex }) {
      if (!!this.element.options.controlColColorTernaryexpression && !!this.element.options.controlColfield) {
        var controlColColorTernaryexpressionArr = this.element.options.controlColColorTernaryexpression
        var controlColfield = this.element.options.controlColfield
        for (var i = 0; i < controlColColorTernaryexpressionArr.length; i++) {
          if (eval(controlColColorTernaryexpressionArr[i].key)) {
            if (column.property == controlColfield) {
              return controlColColorTernaryexpressionArr[i].value
            }
          }
        }
      } else {
        return ''
      }
    },
    //弹出框点击
    inputBtnClick(element) {
      // this.Searchval = element
      // this.$nextTick(()=>{
      //     this.$refs.popupComponents.view(element, {}, this.searchList,this.parentRowData)
      // })
    },
    //弹出框选择值之后刷新页面
    updateChoose() {
      this.$forceUpdate();
    },
    //每页显示条数切换
    sizeChange(val) {
      this.page.pageSize = val
      this.getData('排序', this.parentRowData)
    },
    //当前页数切换
    currentChange(val) {
      if (this.isUsefalsepage) {
        this.page.currentPage = val
        // console.log(val, this.usefalsepageChildData, this.tableData)
        this.childrensInfo[this.tableData] = this.usefalsepageChildData[val - 1]
        this.$forceUpdate()
      } else {
        this.page.currentPage = val
        this.getData('分页', this.parentRowData)
      }
    },
    //表格操作列保存
    saveTableColumn() {
      this.tablenoCheckList = []
      this.tableallCheckList.forEach((item) => {
        if (item.isSelect == 0) {
          this.tablenoCheckList.push(item.model)
        }
      })
      this.isshowpopover = false
    },
    //表格操作列重置
    resetTableColumn() {
      this.tablenoCheckList = []
      this.tableallCheckList.forEach((item) => {
        item.isSelect = 1
      })
      this.isshowpopover = false
    },
    //表格的唯一值
    getRowKeys(row) {
      return row.frontid
    },
    //子表按钮点击
    btnClick(val, buttonlists) {
      if (val.options.isCustomizedprocessing) {
        this.$refs.customizationComponents.childTableButtons(val, this.childSelectData)
      } else {
        if (!!this[val.options.event]) {
          this[val.options.event](val)
        }
      }
    },
    //导出按钮
    exportData(val) {
      if (!!this.detailInfos.id) {
        var that = this
        var loading;
        loading = Loading.service({
          fullscreen: true,
          text: '拼命加载中...',
          background: 'rgba(255, 255, 255, 0.5)'
        });
        var url = Config.dev_url + '/api-apps/app/' + this.$route.params.app + '/commonChlidExportExc/' + this.detailInfos.id + '?table=' + this.element.options.tablename
        var excelCustomAttrs = []
        this.tableallCheckList.forEach((item) => {
          if (this.tablenoCheckList.indexOf(item.model) == -1) {
            excelCustomAttrs.push(item.model)
          }
        })
        this.$axios({
          method: 'post',
          url: url,
          responseType: 'blob',
          headers: {
            'Authorization': "Bearer " + this.getCookie("demand_access_token"),
            "client_type": "DESKTOP_WEB"
          },
          data: {
            excelCustomAttrs: excelCustomAttrs,
            table: this.element.options.tablename,
          }
        }).then((res) => {
          console.log(res)
          loading.close();
          var filename = "列表数据.xlsx";
          var blob = res.data;
          var link = document.createElement("a");
          var objecturl = URL.createObjectURL(blob);
          link.href = objecturl;
          link.download = filename;
          link.click();
        }).catch((err) => {
        });
        // var xhr = new XMLHttpRequest();
        // xhr.open("POST", url, true);
        // xhr.responseType = "blob";
        // xhr.setRequestHeader("client_type", "DESKTOP_WEB");
        // xhr.setRequestHeader("Authorization", "Bearer " + this.getCookie("access_token"));
        // var that = this
        // xhr.onload = function () {
        //     console.log(this.status)
        //     if (this.status == 200) {
        //         loading.close();
        //         if(!!val.options.fileName){
        //             var filename = val.options.fileName;
        //         }else{
        //             var filename = "列表数据.xlsx";
        //         }
        //         console.log(this.response)
        //         var blob = this.response;
        //         var link = document.createElement("a");
        //         var objecturl = URL.createObjectURL(blob);
        //         link.href = objecturl;
        //         link.download = filename;
        //         link.click();
        //     } else {
        //     loading.close();
        //     that.$message.warning('导出失败!')
        //     }
        // };
        // xhr.send();
      } else {
        this.$message.warning("请先保存当前数据再进行操作")
      }
    },
    //自定义导出按钮
    customexportData(val) {
      if (!!this.detailInfos.id) {
        var that = this
        var loading;
        loading = Loading.service({
          fullscreen: true,
          text: '拼命加载中...',
          background: 'rgba(255, 255, 255, 0.5)'
        });
        var url = Config.dev_url + val.options.requesturl + '/' + this.detailInfos.id
        var xhr = new XMLHttpRequest();
        xhr.open("POST", url, true);
        xhr.responseType = "blob";
        xhr.setRequestHeader("client_type", "DESKTOP_WEB");
        xhr.setRequestHeader("Authorization", "Bearer " + this.getCookie("access_token"));
        var that = this
        xhr.onload = function () {
          console.log(this.status)
          if (this.status == 200) {
            loading.close();
            if (!!val.options.fileName) {
              var filename = val.options.fileName;
            } else {
              var filename = "列表数据.xlsx";
            }
            console.log(this.response)
            var blob = this.response;
            var link = document.createElement("a");
            var objecturl = URL.createObjectURL(blob);
            link.href = objecturl;
            link.download = filename;
            link.click();
          } else {
            loading.close();
            that.$message.warning('导出失败!')
          }
        };
        xhr.send();
      } else {
        this.$message.warning("请先保存当前数据再进行操作")
      }
    },
    //自定义下载导入模板按钮
    customdownloadImportTemplate(val) {
      var loading;
      loading = Loading.service({
        fullscreen: true,
        text: '拼命加载中...',
        background: 'rgba(255, 255, 255, 0.5)'
      });
      var url = Config.dev_url + val.options.requesturl
      var xhr = new XMLHttpRequest();
      xhr.open("POST", url, true);
      xhr.responseType = "blob";
      xhr.setRequestHeader("client_type", "DESKTOP_WEB");
      xhr.setRequestHeader("Authorization", "Bearer " + this.getCookie("access_token"));
      var that = this
      xhr.onload = function () {
        console.log(this.status, val.options)
        if (this.status == 200) {
          loading.close();
          if (!!val.options.fileName) {
            var filename = val.options.fileName;
          } else {
            var filename = "导入数据模板.xlsx";
          }
          console.log(this.response)
          var blob = this.response;
          var link = document.createElement("a");
          var objecturl = URL.createObjectURL(blob);
          link.href = objecturl;
          link.download = filename;
          link.click();
        } else {
          loading.close();
          that.$message.warning('导出失败!')
        }
      };
      xhr.send();
    },
    //下载导入模板按钮
    downloadImportTemplate(val) {
      var loading;
      loading = Loading.service({
        fullscreen: true,
        text: '拼命加载中...',
        background: 'rgba(255, 255, 255, 0.5)'
      });
      var url = Config.dev_url + '/api-apps/app/' + this.$route.params.app + '/importExcTemplete?table=' + this.element.options.tablename
      var xhr = new XMLHttpRequest();
      xhr.open("POST", url, true);
      xhr.responseType = "blob";
      xhr.setRequestHeader("client_type", "DESKTOP_WEB");
      xhr.setRequestHeader("Authorization", "Bearer " + this.getCookie("access_token"));
      var that = this
      xhr.onload = function () {
        console.log(this.status)
        if (this.status == 200) {
          loading.close();
          if (!!val.options.fileName) {
            var filename = val.options.fileName;
          } else {
            var filename = "导入数据模板.xlsx";
          }
          console.log(this.response)
          var blob = this.response;
          var link = document.createElement("a");
          var objecturl = URL.createObjectURL(blob);
          link.href = objecturl;
          link.download = filename;
          link.click();
        } else {
          loading.close();
          that.$message.warning('导出失败!')
        }
      };
      xhr.send();
    },
    //主表id不存在的导入按钮
    noimportData() {
      this.$message.warning("请先保存当前数据之后再进行操作")
    },
    //主表id不存在的自定义导入按钮
    nocustomimportData() {
      this.$message.warning("请先保存当前数据之后再进行操作")
    },
    //自定义导入按钮
    customimportDataBtn(val) {
      this.customimportDataBtnItem = val
    },
    //导入按钮
    importDataBtn(val) {
      this.importDataBtnItem = val
    },
    //自定义导入按钮
    customimportData(file, fileList) {
      if (file.name == '') {
        this.$message.warning('请选择所要上传的文件')
      } else {
        var formData = new FormData();
        formData.append('file', file.raw);
        console.log("上传")
        var config = {
          //添加请求头
          headers: { "Content-Type": "multipart/form-data" },
          //添加上传进度监听事件
          onUploadProgress: e => {
            var completeProgress = ((e.loaded / e.total * 100) | 0) + "%";
            this.progress = completeProgress;
          }
        };
        console.log(formData)
        console.log(uploadUrl, this.customimportDataBtnItem)
        var data = {}
        this.customimportDataBtnItem.options.searchParams.forEach((item) => {
          if (item.value.indexOf('m:') !== -1) {
            data[item.key] = this.detailInfos[item.value.substr(item.value.indexOf('m:') + 2, item.value.length)]
          } else {
            data[item.key] = item.value
          }
        })
        var str = ''
        for (let key in data) {
          str += key + '=' + data[key] + '&'
        }
        var params = str.substring(0, str.length - 1);
        console.log(data, params)
        var uploadUrl = Config.dev_url + this.customimportDataBtnItem.options.requesturl + '?' + params;
        this.$axios.post(uploadUrl, formData, config).then((res) => {
          console.log(res)
          this.$refs.myupload2[0].clearFiles()
          if (res.data.code == 0) {
            this.$message.success(res.data.msg)
            this.getData()
          } else {
            this.$message.warning(res.data.msg)
          }
        }).catch((err) => {
        });
      }
    },
    //导入按钮
    importData(file, fileList) {
      if (file.name == '') {
        this.$message.warning('请选择所要上传的文件')
      } else {
        var formData = new FormData();
        formData.append('file', file.raw);
        console.log("上传")
        var config = {
          //添加请求头
          headers: { "Content-Type": "multipart/form-data" },
          //添加上传进度监听事件
          onUploadProgress: e => {
            var completeProgress = ((e.loaded / e.total * 100) | 0) + "%";
            this.progress = completeProgress;
          }
        };
        var uploadUrl = Config.dev_url + '/api-apps/app/' + this.$route.params.app + '/importChildExc?table=' + this.element.options.tablename + '&id=' + this.detailInfos.id;
        this.$axios.post(uploadUrl, formData, config).then((res) => {
          console.log(res)
          this.$refs.myupload1[0].clearFiles()
          if (res.data.code == 0) {
            this.$message.success(res.data.msg)
            this.getData()
          } else {
            this.$message.warning(res.data.msg)
          }
        }).catch((err) => {
        });
      }
    },
    //获取列表高级搜索下拉框数据
    getRemoteSelectData(item) {
      //下拉框获取数据字典
      if (item.type == 'select' && item.options.remote == 1 && !!item.options.dictionaryCode) {
        var url = Config.dev_url + '/api-user/dicts/findByCode?code=' + item.options.dictionaryCode;
        this.$axios.get(url).then((res) => {
          this.$set(item.options, 'selectData', res.data.subDicts)
        }).catch((err) => {
        });
      }
      //下拉框获取自定义远端数据值
      if (item.type == 'select' && item.options.remote == 2) {
        var obj = {}
        var methods = item.options.remoteData.methods;  //查询方式
        var options = item.options.remoteData.options   //查询参数
        // 处理查询条件
        for (var i = 0; i < options.length; i++) {
          if (!!options[i].key && !!options[i].value) {  //判断查询条件参数是否存在
            if (options[i].isFixedValue) {    //判断查询条件的value值是否是固定值
              obj[options[i].key] = options[i].value
            }
          }
        }
        //根据请求方式判断传参形式
        if (methods == 'get') {
          if (JSON.stringify(obj) == "{}") {
            var url = Config.dev_url + item.options.remoteData.url
          } else {
            var str = ''
            for (let key in obj) {
              str += key + '=' + obj[key] + '&'
            }
            var params = str.substring(0, str.length - 1)
            var url = Config.dev_url + item.options.remoteData.url + '?' + params
          }
          this.$axios.get(url).then((res) => {
            this.$set(item.options, 'selectData', res.data.data)
          }).catch((err) => {
          });
        } else if (methods == 'post') {
          var url = Config.dev_url + item.options.remoteData.url
          this.$axios.post(url, obj).then((res) => {
            this.$set(item.options, 'selectData', res.data.data)
          }).catch((err) => {
          });
        }
      }
    },
    //查询子表最大值用来做自增字段
    getMaxNum() {
      if (!!this.detailInfos.id && !!this.element.options.autoAddFiled) {
        var url = Config.dev_url + '/api-apps/app/' + this.$route.params.app + '/findMaxNum?id=' + this.detailInfos.id + '&uuidflag=' + this.element.options.uniqueIdentification + '&column=' + this.element.options.autoAddFiled
        this.$axios.get(url).then((res) => {
          this.maxNum = res.data.data
        }).catch((err) => {
        });
      }
    },
    //权限设置
    permissionSetting(arr, str) {
      if (!!arr && arr.length != 0) {
        var newArr = [];
        for (var i = 0; i < arr.length; i++) {
          newArr.push(arr[i].name)
        }
        var res = newArr.includes(this.currentuser.roleName)
        if (str == 'look') {
          return !res
        } else {
          return res
        }
      } else {
        if (str == 'look') {
          return true
        } else {
          return false
        }
      }
    },
    //组件禁用、隐藏条件解析
    componentsIsShow(element, hideCondition) {
      var str = hideCondition
      if (!!hideCondition) {
        var arr = hideCondition.split('&&')
        var Arr = arr.map((arrItem) => {
          if (arrItem.indexOf('||') !== -1) {
            return arrItem.split("||")
          } else {
            return arrItem
          }
        })
        var newArr = Arr.flat(Infinity)
        newArr.forEach((newArrItem) => {
          if (newArrItem.indexOf('(') !== -1) {
            newArrItem = newArrItem.substr(1, newArrItem.length)
          } else if (newArrItem.indexOf(')') !== -1) {
            newArrItem = newArrItem.substr(0, newArrItem.length - 1)
          } else if (newArrItem.indexOf('!==') !== -1 && newArrItem.indexOf(':') !== -1) {
            if (JSON.stringify(this.detailInfos) !== "{}") {
              var Detailfiled = newArrItem.substr(1, newArrItem.indexOf('!==') - 1)
              var filedValue = newArrItem.substr(newArrItem.indexOf('!==') + 3, newArrItem.length)
              if (filedValue.indexOf('currentuser:') !== -1) {
                filedValue = filedValue.replace(filedValue, this.currentuser[filedValue.substr(12, filedValue.length)])
              }
              if (this.detailInfos[Detailfiled] != filedValue) {
                str = str.replace(newArrItem, true)
              } else {
                str = str.replace(newArrItem, false)
              }
            }
          } else if (newArrItem.indexOf(':') !== -1 && newArrItem.indexOf('==') !== -1) {
            if (JSON.stringify(this.detailInfos) !== "{}") {
              var Detailfiled = newArrItem.substr(1, newArrItem.indexOf('=') - 1)
              var filedValue = newArrItem.substr(newArrItem.indexOf('=') + 2, newArrItem.length)
              if (filedValue.indexOf('currentuser:') !== -1) {
                filedValue = filedValue.replace(filedValue, this.currentuser[filedValue.substr(12, filedValue.length)])
              }
              if (!!this.detailInfos[Detailfiled] && this.detailInfos[Detailfiled] == filedValue) {
                str = str.replace(newArrItem, true)
              } else {
                str = str.replace(newArrItem, false)
              }
            }
          } else if (newArrItem.indexOf(':') !== -1 && newArrItem.indexOf('==') == -1) {
            if (JSON.stringify(this.detailInfos) !== "{}") {
              var Detailfiled = newArrItem.substr(newArrItem.indexOf(':') + 1, newArrItem.length)
              var replaceStr = newArrItem.substr(newArrItem.indexOf(':'), newArrItem.length)
              if (!!this.detailInfos[Detailfiled]) {
                str = str.replace(replaceStr, true)
              } else {
                str = str.replace(replaceStr, false)
              }
            }
          }
        })
        if (str.indexOf(':') == -1) {
          return eval(str)
        }
      } else {
        return false
      }
    },
    //最终禁用处理
    allcomponentsDisabledfun(element, str) {
      if (str == "button") {
        if (element.options.event == 'downloadImportTemplate' || element.options.event == 'customdownloadImportTemplate' || element.options.event == 'exportData' || element.options.event == 'customexportData') {
          return false
        } else if (element.options.isDisabled) {
          return true
        } else if (this.permissionSetting(element.options.readonlyRoleList, 'readonly')) {
          return true
        } else if (this.$store.getters.getcustomformDisabled()) {
          return true
        } else if (this.componentsIsShow(element, element.options.disabledCondition)) {
          return true
        } else {
          return false
        }
      } else if (str == "table") {
        if (element.options.disabled) {
          return true
        } else if (this.permissionSetting(element.options.readonlyRoleList, 'readonly')) {
          return true
        } else if (this.$store.getters.getcustomformDisabled()) {
          return true
        } else if (this.componentsIsShow(element, element.options.disabledCondition)) {
          return true
        } else if (element.options.hierarchydisabled && !element.options.disabled) {
          return true
        } else {
          return false
        }
      }
    }
  },
  mounted() {
    //存储该应用下得所有子表json信息
    this.childTableJson.push(this.element)
    //根据当前表格得列表显示列为高级搜索以及表格控制列做准备
    this.element.columns.forEach((item) => {
      //表格控制列
      if (!item.options.isvisible) {
        var cloneItem = JSON.parse(JSON.stringify(item))
        cloneItem.isSelect = 1
        this.tableallCheckList.push(cloneItem)
      }
      //高级搜索下拉框数据
      if (item.type == 'select') {
        this.getRemoteSelectData(item)
      }
    })
  }
}
</script>

<style>
</style>